// ════════════════════════════════════════════════════════════════════
// W'ILY'S PIER — pierShellSig.js   ·   THE SHELL'S FINGERPRINT
// ────────────────────────────────────────────────────────────────────
// pier_shell.glb (the Blender deck: planks, fascia, rails, posts, piles,
// braces, alley fences) is built FROM the plan. This is the plan's
// fingerprint: the builder stamps it into the glb, the game recomputes it
// live, and on ANY mismatch the code-built <Deck/> stands in. So moving a
// shopfront without re-running the Blender builder can never put a rail
// across a door — it just falls back until the shell is rebuilt.
// Pure module (Node loads it): imports only pierPlan.js.
// ════════════════════════════════════════════════════════════════════
import { COLS, ROWS, MAP, FRONTS, ALLEYS } from "./pierPlan.js";

export const SHELL_KIT_VERSION = 1;   // bump when the builder changes what the glb MEANS (not how it looks)

export function planPayload() {
  return {
    v: SHELL_KIT_VERSION, cols: COLS, rows: ROWS,
    map: MAP.map((r) => r.join("")),
    fronts: FRONTS.map((f) => [f.id, f.face, f.edge, f.a0, f.a1]),
    alleys: ALLEYS.map((g) => [g.face, g.edge, g.s0, g.s1]),
  };
}

// FNV-1a over the canonical JSON — short, stable, identical in Node and the browser
export function planSig() {
  const s = JSON.stringify(planPayload());
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
  return h.toString(16).padStart(8, "0");
}
